/**
 * Features Page - Prerendered Static Page Example
 *
 * This page demonstrates proper prerendering configuration.
 * It's fully static with no API calls or dynamic data.
 *
 * ## Why This Page is Prerendered
 *
 * ✅ Fully static content (no API calls)
 * ✅ Same for all users (no personalization)
 * ✅ Public (no authentication required)
 * ✅ Content defined at build time
 *
 * ## Benefits
 *
 * - ⚡ Instant page load (served as static HTML)
 * - 📈 Better SEO (full HTML for crawlers)
 * - 💰 Lower hosting costs (no server compute)
 * - 🌍 Excellent CDN caching
 *
 * @see https://svelte.dev/docs/kit/page-options#prerender
 */

// Enable prerendering - generates static HTML at build time
export const prerender = true;

// Still enable SSR for the initial HTML generation
export const ssr = true;

// Enable client-side hydration for interactivity
export const csr = true;
